import { useState } from "react"
import { Outlet, NavLink } from "react-router"
import { useAuth } from "@/lib/auth"
import { LayoutDashboard, ArrowLeft, Sparkles, DollarSign, Users, Menu, X } from "lucide-react"

const OPS_NAV_ITEMS = [
  { to: "/admin", label: "Dashboard", end: true, icon: LayoutDashboard },
  { to: "/admin/ai", label: "AI Routing", end: false, icon: Sparkles },
  { to: "/admin/costs", label: "Costs", end: false, icon: DollarSign },
  { to: "/admin/users", label: "Users", end: false, icon: Users },
]

export function OpsShell() {
  const { user, logout } = useAuth()
  const [railOpen, setRailOpen] = useState(false)

  const initials = user?.name
    ? user.name.split(" ").map((w) => w[0]).join("").slice(0, 2).toUpperCase()
    : user?.email?.slice(0, 2).toUpperCase() || "?"

  return (
    <div className="shell">
      {/* Mobile hamburger */}
      <button
        className="shell__mobile-toggle"
        onClick={() => setRailOpen(true)}
        type="button"
        aria-label="Open navigation"
      >
        <Menu className="h-5 w-5" />
      </button>

      {/* Mobile overlay */}
      {railOpen && (
        <div
          className="shell__mobile-overlay"
          onClick={() => setRailOpen(false)}
        />
      )}

      <nav className={`rail${railOpen ? " rail--open" : ""}`} aria-label="Ops navigation">
        <div className="rail__brand">
          <div className="rail__brand-mark">S</div>
          Ops Admin
          <button
            className="rail__mobile-close"
            onClick={() => setRailOpen(false)}
            type="button"
            aria-label="Close navigation"
          >
            <X className="h-4 w-4" />
          </button>
        </div>

        <div className="rail__nav" role="list">
          {OPS_NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              role="listitem"
              onClick={() => setRailOpen(false)}
              className={({ isActive }) =>
                `rail__nav-item${isActive ? " rail__nav-item--active" : ""}`
              }
            >
              <item.icon className="rail__nav-icon" />
              {item.label}
            </NavLink>
          ))}

          <div className="border-t border-border mx-4 my-3" />
          <NavLink to="/properties" className="rail__nav-item" onClick={() => setRailOpen(false)}>
            <ArrowLeft className="rail__nav-icon" />
            Properties
          </NavLink>
        </div>

        <div className="rail__footer">
          <div className="rail__user">
            <div className="rail__user-avatar">{initials}</div>
            <span>{user?.name || user?.email || ""}</span>
          </div>
          <button className="rail__signout" onClick={logout} type="button">
            Sign out
          </button>
        </div>
      </nav>

      <main className="main main--wide">
        <Outlet />
      </main>
    </div>
  )
}

